export default {
  'emailTemplate.title': '邮件模板',
  'emailTemplate.form.keyword': '关键词',
  'emailTemplate.form.keyword.placeholder': '搜索 名称 / Key / 语种',
  'emailTemplate.form.merchant': '商户筛选',
  'emailTemplate.form.merchant.placeholder': '全部商户',
  'emailTemplate.form.search': '查询',
  'emailTemplate.form.reset': '重置',
  'emailTemplate.operation.add': '新增模板',
  'emailTemplate.operation.refresh': '刷新',
  'emailTemplate.alert.merchantRequired':
    '新增模板前请先选择商户。列表可查看全部商户模板。',
  'emailTemplate.columns.index': '#',
  'emailTemplate.columns.merchantName': '商户',
  'emailTemplate.columns.name': '名称',
  'emailTemplate.columns.locale': '语种',
  'emailTemplate.columns.source': '来源',
  'emailTemplate.columns.enabled': '启用',
  'emailTemplate.columns.createdAt': '创建时间',
  'emailTemplate.columns.updatedAt': '更新时间',
  'emailTemplate.columns.operations': '操作',
  'emailTemplate.columns.operations.edit': '编辑',
  'emailTemplate.columns.operations.preview': '预览',
  'emailTemplate.columns.operations.copy': '复制翻译',
  'emailTemplate.columns.operations.delete': '删除',
  'emailTemplate.columns.operations.deleteConfirm': '确认删除模板「{name}」？',
  'emailTemplate.columns.operations.deleteDisabled': '内置默认模板不可删除',
  'emailTemplate.source.builtin': '内置',
  'emailTemplate.source.custom': '自定义',
  'emailTemplate.enabled.yes': '启用',
  'emailTemplate.enabled.no': '停用',
  'emailTemplate.editor.back': '返回列表',
  'emailTemplate.editor.createTitle': '新增邮件模板',
  'emailTemplate.editor.editTitle': '编辑模板',
  'emailTemplate.editor.defaultSubject': '默认主题',
  'emailTemplate.editor.hint': '填写左侧内容后，右侧将实时预览渲染效果',
  'emailTemplate.editor.panel.edit': '编辑',
  'emailTemplate.editor.panel.preview': '预览',
  'emailTemplate.editor.previewLoading': '预览（生成中…）',
  'emailTemplate.editor.templateKey': '模板 Key',
  'emailTemplate.editor.templateKey.placeholder': '例如：order_paid_notice',
  'emailTemplate.editor.name': '模板名称',
  'emailTemplate.editor.engine': '模板引擎',
  'emailTemplate.editor.enabled': '是否启用',
  'emailTemplate.editor.subject': '邮件主题',
  'emailTemplate.editor.htmlBody': '邮件正文（HTML）',
  'emailTemplate.editor.remark': '备注（可选）',
  'emailTemplate.editor.restore': '恢复默认',
  'emailTemplate.editor.save': '保存',
  'emailTemplate.editor.create': '创建',
  'emailTemplate.editor.restoreConfirm':
    '将覆盖当前主题与正文，且不可撤销。确认要恢复吗？',
  'emailTemplate.editor.restoreOk': '确认恢复',
  'emailTemplate.editor.restoreCancel': '取消',
  'emailTemplate.editor.previewEmpty': '请在左侧填写主题与正文后预览',
  'emailTemplate.editor.previewErrors': '渲染提示',
  'emailTemplate.copy.title': '复制并翻译模板',
  'emailTemplate.copy.hint':
    '将基于当前模板调用 AI 翻译为目标语种，并生成一条新的模板记录（保留相同 templateKey）。',
  'emailTemplate.copy.source': '源模板',
  'emailTemplate.copy.targetLocale': '目标语种',
  'emailTemplate.copy.targetLocale.placeholder': '选择要翻译成的语种',
  'emailTemplate.copy.confirm': '开始翻译并复制',
  'emailTemplate.copy.cancel': '取消',
  'emailTemplate.preview.title': '邮件预览',
  'emailTemplate.preview.renderedSubject': '渲染后主题',
  'emailTemplate.preview.empty': '暂无预览内容',
  'emailTemplate.preview.hint': '使用模板示例变量渲染，仅供样式参考。',
  'emailTemplate.preview.close': '关闭',
  'emailTemplate.preview.goEdit': '去编辑',
  'emailTemplate.message.fetchFailed': '获取模板列表失败',
  'emailTemplate.message.saveFailed': '保存失败',
  'emailTemplate.message.nameRequired': '请填写模板名称',
  'emailTemplate.message.subjectRequired': '请填写邮件主题',
  'emailTemplate.message.htmlRequired': '请填写邮件正文（HTML）',
  'emailTemplate.message.keyRequired': '请填写模板 Key',
  'emailTemplate.message.keyInvalid': '模板 Key 仅支持小写字母/数字/下划线',
  'emailTemplate.message.copyLocaleRequired': '请选择目标语种',
  'emailTemplate.message.copyHtmlEmpty': '源模板 HTML 为空，无法翻译',
  'emailTemplate.message.copyFailed': '复制翻译失败',
  'emailTemplate.message.previewFailed': '预览加载失败',
  'emailTemplate.message.createSuccess': '创建成功',
  'emailTemplate.message.updateSuccess': '保存成功',
  'emailTemplate.message.deleteSuccess': '删除成功',
  'emailTemplate.message.restoreSuccess': '已恢复默认',
};
